<template>
  <div
    style="position:absolute;top:0;left:0;width:100%;height:calc(100vh);background-color:rgba(0,0,0,.7);color:white;font-size:30px"
  >
    <div
      class="column justify-center content-center items-center full-height"
    >
      <q-icon name="error" size="4em"></q-icon>
      <div class="q-pa-xl text-center" style="font-size:.55em">
        {{ message ? message : defaultMessage }}
      </div>
      <div class="row justify-center items-center content-center">
        <q-btn
          @click="$emit('cancel')"
          class="q-mr-sm"
          size="md"
          color="white"
          outline
          label="Give Up"
          v-if="showGiveUp"
        />
        <q-btn
          @click="$emit('action')"
          class="q-ml-sm"
          size="md"
          color="white"
          outline
          label="Try Again"
          v-if="showRetry"
        />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Oops",
  props: {
    showGiveUp: {
      type: Boolean,
      default: true
    },
    showRetry: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultMessage: "Oops...Something didn't work as expected."
    };
  }
};
</script>
